import { render, staticRenderFns } from "./Rule.vue?vue&type=template&id=7381fdbc&scoped=true"
import script from "./Rule.vue?vue&type=script&lang=ts"
export * from "./Rule.vue?vue&type=script&lang=ts"
import style0 from "./Rule.vue?vue&type=style&index=0&id=7381fdbc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7381fdbc",
  null
  
)

export default component.exports